import Box from "@mui/material/Box";
import CardActionArea from "@mui/material/CardActionArea";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { ITarget } from "../config/targets.config";

interface IChooserCardProps {
  target: ITarget;
}

export const ChooserCard = ({ target }: IChooserCardProps) => {
  const content = (
    // A plain flex column rather than a Stack: Stack's spacing sets marginTop on every child after
    // the first, which would beat the `mt: auto` that pins the text block to the bottom.
    <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", height: "100%", p: 3 }}>
      {/* Decorative: the heading below carries the same meaning. */}
      <Box component="img" src={target.iconSrc} alt="" sx={{ height: 90, maxWidth: "100%" }} />
      <Stack spacing={1} alignItems="center" sx={{ mt: "auto", pt: 2 }}>
        <Typography variant="h5" component="h3" textAlign="center">
          {target.title}
        </Typography>
        {!target.isEnabled && (
          <Typography variant="body2" color="text.secondary" textAlign="center">
            Dieser Bereich steht derzeit nicht zur Verfügung.
          </Typography>
        )}
      </Stack>
    </Box>
  );

  return (
    <Paper elevation={2} sx={{ height: "100%", overflow: "hidden" }}>
      {target.isEnabled ? (
        <CardActionArea
          component="a"
          href={target.url}
          target="_blank"
          rel="noopener noreferrer"
          sx={{ height: "100%" }}
        >
          {content}
        </CardActionArea>
      ) : (
        // Greyed rather than hidden, so a stage missing a URL looks wrong instead of complete.
        <Box sx={{ height: "100%", filter: "grayscale(1)", opacity: 0.6 }}>{content}</Box>
      )}
    </Paper>
  );
};
